import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchCreateRegisteringNewArabianHorseFoalServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchOwnerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownthunk,
  FetchUpdateRegisteringNewArabianHorseFoalServiceRequestthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import { FetchHorseColorsthunk } from "../Redux/LookUp/LookUpAction";
import axios from "../axios/axios";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import { isMoreThanDays } from "../helper/isMoreThanDays";
import axiosMap from "axios";
import EahsForm from "../components/EahsForm";
import MapWithSearchAndLocate from "../components/PickAPlace";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import { checkPenalty, getHorseCategories } from "./sharedAPI/lookUpApis";
import { isEmpty } from "../helper/validaiteInputs";
//import PickAPlace from "./PickAPlace";

export default function RequestRegisteringNewArabianHorseFoal() {
  //env
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const { horseColorsData } = useSelector(
    (state) => state.lookUpSlice
  );

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    ownerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownData,
    createRegisteringNewArabianHorseFoalServiceRequestData,
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));

  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;
  const [selctedHorseType, setSelctedHorseType] = useState()
  const [horseTypeOptions, setHorseOptions] = useState([]);
  const [hasPanelty, setHasPanelty] = useState(false);

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    coveringCertificate: "",
    coveringCertificateDrop: {
      label: translate("web.coveringCertificate", "Covering Certificate"),
      value: null,
    },
    mareHorse: "",
    stallionHorse: "",
    mareOwner: "",
    stallionOwner: "",
    breeder: "",
    coveringDate: "",
    // to do
    horseType: selctedHorseType?.value,
    nameEn: "",
    nameAr: "",
    birthDate: null,
    color: "",
    colorDrop: {
      label: translate("web.color", "Color"),
      value: null,
    },
    sex: "Stallion",
    emirate: "",
    emirateDrop: {
      label: translate("web.emirate", "Emirate"),
      value: null,
    },
    area: "",
    areaDrop: {
      label: translate("web.area", "Area"),
      value: null,
    },
    locationOnMap: "",

    isRegistration: true,
    address: "",
    mobile: "",

    eventName: "",
    comment: "",
    ownerComment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",
    registeringNewArabianHorseFoalId: null,
    gpsLocationLink: "",
    term1: false,
    violationPaymentHorseRegistrationDelay: "",
  });

  const [errorCoveringCertificate, setErrorCoveringCertificate] = useState(false);
  const [errorSelctedHorseType, setErrorSelctedHorseType] = useState(false);
  const [errorNameEn, setErrorNameEn] = useState(false);
  const [errorNameAr, setErrorNameAr] = useState(false);
  const [errorBirthDate, setErrorBirthDate] = useState(false);
  const [errorColor, setErrorColor] = useState(false);
  const [errorEmirate, setErrorEmirate] = useState(false);
  const [errorArea, setErrorArea] = useState(false);
  const [errorMapLocation, setErrorMapLocation] = useState(false);
  const [errorLocationOnMap, setErrorLocationOnMap] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorMobile, setErrorMobile] = useState(false);

  const coveringCertificateRef = useRef(null);
  const selctedHorseTypeRef = useRef(null);
  const nameEnRef = useRef(null);
  const nameArRef = useRef(null);
  const birthDateRef = useRef(null);
  const colorRef = useRef(null);
  const emirateRef = useRef(null);
  const areaRef = useRef(null);
  const mapLocationRef = useRef(null);
  //const locationOnMapRef = useRef(null);
  const addressRef = useRef(null);
  const mobileRef = useRef(null);

  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });

  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //const [geoLocation, setGeoLocation] = useState({ lat: 51.505, lng: -0.09 }); // Default to London
  //const [statusGeoLocation, setStatusGeoLocation] = useState("new");

  const [fullAddress, setFullAddress] = useState("");
  const [latitude, setLatitude] = useState(23.55344);
  const [longitude, setLongitude] = useState(53.56701);
  const [lockey] = useState(Math.floor(Math.random() * 10000 + 1000));

  const [selectedLocation, setSelectedLocation] = useState({
    // lat: 24.4539, // Latitude of Abu Dhabi
    // lng: 54.3773,
    lat: "", // Latitude of Abu Dhabi
    lng: "",
    fullAddress: "",
  });

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const [emiratelistoptions, setEmirateListOptions] = useState([]);
  const [regionsList, setRegionsList] = useState([]);

  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  //function
  const setPhoneNumber = (value) => {
    setFormModel((prev) => ({
      ...prev,
      mobile: value
    }));
  }

  const handleFormChange = (e, input) => {
    if (input === "coveringCertificate") {
      let coveringCertificate = ownerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownData.filter((item) => item.id == e.value);
      checkPenalty(id ?? null, e.value, formModel.birthDate).then(res => { setHasPanelty(res) })
      setFormModel({
        ...formModel,
        coveringCertificate: e.value,
        coveringCertificateDrop: e,
        mareHorse: coveringCertificate[0]?.mare ?? "",
        stallionHorse: coveringCertificate[0]?.stallion ?? "",
        mareOwner: coveringCertificate[0]?.mareOwner ?? "",
        stallionOwner: coveringCertificate[0]?.stallionOwner ?? "",
        coveringDate: coveringCertificate[0]?.coveringDate ?? "",
        //coveringDate: formattedDate,
        breeder: coveringCertificate[0]?.breeder ?? "",
        isEmbryoTransfer: coveringCertificate[0]?.isEmbryoTransfer ?? false,
      });
    } else if (!!input && input === "color") {
      setFormModel({
        ...formModel,
        color: e.value,
        colorDrop: e,
      });
    } else if (!!input && input === "emirate") {
      getRegionListbyID(e.value);

      setFormModel({
        ...formModel,
        emirate: e.value,
        emirateDrop: e,
        area: "",
        areaDrop: {
          label: translate("web.area", "Area"),
          value: null,
        }
      });
    } else if (!!input && input === "area") {
      setFormModel({
        ...formModel,
        area: e.value,
        areaDrop: e,
      });
    } else if (input === "receiveType") {
      setFormModel({
        ...formModel,
        isRegistration: e.target.value === "Registration",
        address: "",
        mobile: ""
      });
    } else if (!!input && input === "nameEn") {
      const regex = /^[a-zA-Z. ]*$/;

      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          nameEn: e.target.value.toUpperCase(),
        });
      }

    } else if (!!input && input === "nameAr") {
      const regex = /^[\u0621-\u064A\u0660-\u0669. ]*$/;

      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          nameAr: e.target.value,
        });
      }
    }
    else if (input === "term1") {
      setFormModel({
        ...formModel,
        term1: e.target.checked,
      });
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.coveringCertificate === ""
    ) {
      setErrorCoveringCertificate(true);
      valid = false;

      coveringCertificateRef?.current?.focus();
      return;
    }
    else {
      setErrorCoveringCertificate(false);
    }
    if (isEmpty(selctedHorseType?.value)) {
      setErrorSelctedHorseType(true);
      valid = false;

      selctedHorseTypeRef?.current?.focus();


      return;
    } else {
      setErrorSelctedHorseType(false)
    }


    if (
      formModel.nameEn === ""
    ) {
      setErrorNameEn(true);
      valid = false;
      nameEnRef?.current?.focus();
      return;
    }
    else {
      setErrorNameEn(false);
    }

    if (
      formModel.nameAr === ""
    ) {
      setErrorNameAr(true);
      valid = false;
      nameArRef?.current?.focus();
      return;
    }
    else {
      setErrorNameAr(false);
    }

    if (
      formModel.birthDate === null
    ) {
      setErrorBirthDate(true);
      valid = false;

      birthDateRef?.current?.focus();
      return;
    }
    else {
      setErrorBirthDate(false);
    }

    const dateToCheck = dayjs(formModel.birthDate);
    const now = dayjs();

    if (dateToCheck.isAfter(now)) {
      setErrorBirthDate(true);
      valid = false;
      birthDateRef?.current?.focus();

      toast.error(
        translate("web.birthDateMustLessEq", "Birth date must less or equal current date")
      );

      return;
    }
    else {
      setErrorBirthDate(false);
    }

    if (
      formModel.color === ""
    ) {
      setErrorColor(true);
      valid = false;
      colorRef?.current?.focus();
      return;
    }
    else {
      setErrorColor(false);
    }

    if (
      formModel.emirate === ""
    ) {
      setErrorEmirate(true);
      valid = false;
      emirateRef?.current?.focus();
      return;
    }
    else {
      setErrorEmirate(false);
    }

    if (
      formModel.area === ""
    ) {
      setErrorArea(true);
      valid = false;
      areaRef?.current?.focus();
      return;
    }
    else {
      setErrorArea(false);
    }

    if (
      selectedLocation.lat === "" && selectedLocation.lng === ""
    ) {
      setErrorMapLocation(true);
      valid = false;

      var _mapLocationRef = mapLocationRef?.current;
      _mapLocationRef.disabled = false;

      _mapLocationRef.focus();

      _mapLocationRef.disabled = true;
      return;
    }
    else {
      setErrorMapLocation(false);
    }

    // if (
    //   formModel.locationOnMap === ""
    // ) {
    //   setErrorLocationOnMap("");
    //   valid = false;
    // }
    // else {
    //   setErrorLocationOnMap("none");
    // }

    if (
      !formModel.isRegistration && (formModel.address === "" || formModel.address == null || formModel.address.length < 50)
    ) {
      setErrorAddress(true);
      valid = false;
      addressRef?.current?.focus();

      toast.error(
        translate("web.errorAddressLength50Chars", "Can not address length less than 50 characters")
      );

      return;
    }
    else {
      setErrorAddress(false);
    }

    if (
      !formModel.isRegistration && (formModel.mobile === "" || formModel.mobile == null)
    ) {
      setErrorMobile(true);
      valid = false;
      mobileRef?.current?.focus();
      return;
    }
    else {
      setErrorMobile(false);
    }

    //terms
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (action == null && (!allTermsChecked || (!formModel.term1 && formModel.birthDate != null && isMoreThanDays(new Date(formModel.birthDate), getServiceDefinitionByIdData.penaltyDuration)))) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1 ||
    //   (!checkedItems.option2 && formModel.birthDate != null && isMoreThanDays(new Date(formModel.birthDate), getServiceDefinitionByIdData.penaltyDuration))
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckAllTerms", "Please Check All Terms")
    //   );
    //   valid = false;
    // }

    if (
      formModel.eventName === "DNANegative" && (formModel.ownerComment === "" || formModel.ownerComment === "null")
    ) {
      toast.error(
        translate("web.pleaseEnterOwnerComment", "Please Enter Owner Comment")
      );
      valid = false;
    }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    _isOnlinePayment.current = isOnlinePayment;
    _status.current = status;

    if (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack" && formModel.eventName !== "DNANegative") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);
      debugger
      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=9&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }

    else {
      if (validInputs()) {
        let params = {
          id: id,
          status: status,
          eventName: formModel.eventName,
          ownerId: getUserID(),

          coveringCertificateId: formModel.coveringCertificate,
          horseNameEn: formModel.nameEn,
          horseNameAr: formModel.nameAr,
          birthDateString: dayjs(formModel.birthDate).format("DD/MM/YYYY"),
          color: formModel.color,
          sex: formModel.sex,
          emirate: formModel.emirate,
          area: formModel.area,
          // locationOnMap: formModel.locationOnMap,
          //latitude: geoLocation.lat,
          //longitude: geoLocation.lng,
          latitude: selectedLocation.lat, //latitude,
          longitude: selectedLocation.lng, //longitude,
          receiveType: formModel.isRegistration ? 1 : 2,
          address: formModel.address,
          mobile: formModel.mobile,
          ownerNote: formModel.ownerComment,
          buttonAction: buttonAction,
          horseCategoryId: selctedHorseType?.value

          // registeringNewArabianHorseFoalId: formModel.registeringNewArabianHorseFoalId,
          // createdBy: localStorage.getItem("EAHSUserID"),
          // serviceDefinitionId: serviceId,
        };

        //if (action == null) {
        dispatch(FetchCreateRegisteringNewArabianHorseFoalServiceRequestthunk(params));
        //} else if (action === "edit" || formModel.eventName === "SentBack" || (action === "approve" && formModel.eventName === "DNANegative")) {
        //dispatch(FetchUpdateRegisteringNewArabianHorseFoalServiceRequestthunk(params));
        //}
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let params = {
      ownerId: element.value,
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    dispatch(FetchOwnerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownthunk(element.value));

    setProfile(element);

    setFormModel({
      ...formModel,
      coveringCertificate: "",
      coveringCertificateDrop: {
        label: translate("web.coveringCertificate", "Covering Certificate"),
        value: null,
      },
      mareHorse: "",
      stallionHorse: "",
      mareOwner: "",
      stallionOwner: "",
      breeder: "",
      coveringDate: "",
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "FoalRegistrations" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };

  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  async function getEmirateList() {
    try {
      const emiratelist = await axios.get('/lookup/getmaincities')

      const formattedData = await emiratelist.data.result.map((item) => ({
        text: item.name,
        value: item.id,
      }));

      setEmirateListOptions(formattedData)
    } catch (error) {
      toast.error(translate("web.errorFetchingEmirateList", "Error fetching emirate list"));
    }
  }

  async function getRegionListbyID(id) {
    try {
      const regionList = await axios.get(`/lookup/getareasbyemirateid?EmirateId=${id}`)
      const formattedData = await regionList.data.result.map((item) => ({
        text: item.name,
        value: item.id,
      }));
      setRegionsList(formattedData)
    } catch (error) {
      toast.error(translate("web.errorFetchingAreaList", "Error fetching area list"));
    }
  }



  const handelDisabledButton = () => {
    if (
      action === "view"
      || (action === "approve" && formModel.eventName !== "SentBack")
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelShowGeneralComments = () => {
    if (
      !!formModel.comment
      || (formModel.eventName === "SentBack" || formModel.eventName === "DNANegative")
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelShowOwnerComment = () => {
    if (formModel.eventName === "SentBack" || formModel.eventName === "DNANegative") {
      return true;
    }
    else {
      return false;
    }
  };

  const handelShowoption2 = () => {
    if (
      formModel.birthDate != null
      && isMoreThanDays(new Date(formModel.birthDate), getServiceDefinitionByIdData.penaltyDuration)
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelShowGeneralButtons = () => {
    if (
      action == null || action === "edit"
      ||
      (action === "approve"
        &&
        (
          formModel.eventName === "SentBack"
          || formModel.eventName === "DNANegative"
          || (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
        )
      )
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const handelShowDraftButton = () => {
    if (action == null || action === "edit") {
      // if (formModel.eventName === "" || formModel.eventName === "Draft") {
      return true;
    }
    else {
      return false;
    }
  };

  // 1) common base check
  const canAttemptPayment = () =>
    getServiceDefinitionByIdData.serviceFees > 0 &&
    formModel.eventName !== "SentBack" &&
    action !== "view";

  // 2) your existing “option 2” check (unchanged)
  const canUseOption2 = () =>
    handelShowoption2() &&
    action !== "view" &&
    (formModel.violationPaymentHorseRegistrationDelay === "" ||
      formModel.violationPaymentHorseRegistrationDelay == null);

  // 3) the Pay button needs the base + its own conditions
  const handleShowPayButton = () => {
    return hasPanelty  || (formModel.eventName === "DNANegative");
    return (
      (canAttemptPayment() &&
        (formModel.paymentStatus === "" ||
          formModel.paymentStatus === "Pendding")) ||
      canUseOption2()
      || formModel.eventName === "DNANegative"
    );
  };

  // 4) the Pay-Later button is “all the Pay-button rules” +
  // “participateWithoutPayment must be true”
  const handleShowPayLaterButton = () => {
    return (
      userProfile?.participateWithoutPayment === true &&
      handleShowPayButton()
    );
  };

  const handelShowSubmitButton = () => {
    // your original “base” rules for when submit *could* show
    const baseShow =
      (
        getServiceDefinitionByIdData.serviceFees === 0 &&
        (action == null || action === "edit")
      ) ||
      (action === "approve" && formModel.eventName === "SentBack");

    // if any “pay” button is showing, we hide submit
    const paymentPending =
      handleShowPayButton() ||
      handleShowPayLaterButton();

    return baseShow && !paymentPending;
  };

  const handelMinDateForBirthDate = () => {
    let formattedDate = "";

    if (formModel.coveringDate !== "") {

      const [day, month, year] = formModel.coveringDate.split('/');

      // Create a Date object
      const date = new Date(`${year}-${month}-${day}`);
      // Add 9 months
      date.setMonth(date.getMonth() + 9);

      // Add 20 days
      date.setDate(date.getDate() + 20);

      // Format back to YYYY/MM/DD
      formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
    }

    return dayjs(formattedDate).format("YYYY-MM-DD")
  };

  const handelMaxDateForBirthDate = () => {
    let formattedDate = "";

    if (formModel.coveringDate !== "") {

      const [day, month, year] = formModel.coveringDate.split('/');

      // Create a Date object
      const date = new Date(`${year}-${month}-${day}`);
      // Add 12 months
      date.setMonth(date.getMonth() + 12);

      // Add 10 days
      date.setDate(date.getDate() + 10);

      // Format back to YYYY/MM/DD
      formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;

    }

    return dayjs(formattedDate).format("YYYY-MM-DD")
  };

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }


    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    dispatch(FetchHorseColorsthunk({ langauge: currentLanguage }));

    getEmirateList();
    getHorseCategories().then(res => {
      setHorseOptions(res);
    });

    dispatch(FetchOwnerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownthunk(getUserID()));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId === serviceId)
    ) {
      const selectedHorseTypeServer = horseTypeOptions?.find(x => x?.value == getServicesRequestByIdData?.registeringNewArabianHorseFoal?.horseCategoryId)
      if (((!!formModel?.coveringCertificate) || (!!getServicesRequestByIdData?.registeringNewArabianHorseFoal?.coveringCertificateId)) && ((!!formModel?.birthDate) || (!!getServicesRequestByIdData?.registeringNewArabianHorseFoal?.birthDate))) {
        setTimeout(() => {
          checkPenalty(id, !!formModel?.coveringCertificate ? formModel?.coveringCertificate : getServicesRequestByIdData?.registeringNewArabianHorseFoal?.coveringCertificateId, !!formModel?.birthDate ? formModel?.birthDate : dayjs(getServicesRequestByIdData.registeringNewArabianHorseFoal.birthDate).format("YYYY-MM-DD")).then(res => {
            setHasPanelty(res)
          })
        }, 500);
      }

      setSelctedHorseType(selectedHorseTypeServer);
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
        registeringNewArabianHorseFoalId: getServicesRequestByIdData.registeringNewArabianHorseFoal.registeringNewArabianHorseFoalId,

        coveringCertificate: getServicesRequestByIdData.registeringNewArabianHorseFoal.coveringCertificateId,
        coveringCertificateDrop: {
          label: getServicesRequestByIdData.registeringNewArabianHorseFoal.referenceNumber + " / " + translate("web.mare", "Mare") + ":" + getServicesRequestByIdData.registeringNewArabianHorseFoal.mare + " / " + translate("web.stallion", "Stallion") + ":" + getServicesRequestByIdData.registeringNewArabianHorseFoal.stallion,
          value: getServicesRequestByIdData.registeringNewArabianHorseFoal.coveringCertificateId,
        },

        mareHorse: getServicesRequestByIdData.registeringNewArabianHorseFoal.mare,
        stallionHorse: getServicesRequestByIdData.registeringNewArabianHorseFoal.stallion,
        mareOwner: getServicesRequestByIdData.registeringNewArabianHorseFoal.mareOwner,
        stallionOwner: getServicesRequestByIdData.registeringNewArabianHorseFoal.stallionOwner,
        coveringDate: getServicesRequestByIdData.registeringNewArabianHorseFoal.coveringDate,
        breeder: getServicesRequestByIdData.registeringNewArabianHorseFoal.breeder,
        nameEn: getServicesRequestByIdData.registeringNewArabianHorseFoal.horseNameEn,
        nameAr: getServicesRequestByIdData.registeringNewArabianHorseFoal.horseNameAr,
        birthDate: getServicesRequestByIdData.registeringNewArabianHorseFoal.birthDate != null ? dayjs(getServicesRequestByIdData.registeringNewArabianHorseFoal.birthDate).format("YYYY-MM-DD") : null,
        color: getServicesRequestByIdData.registeringNewArabianHorseFoal.color,
        colorDrop: {
          label: getServicesRequestByIdData.registeringNewArabianHorseFoal.colorName,
          value: getServicesRequestByIdData.registeringNewArabianHorseFoal.color,
        },
        sex: getServicesRequestByIdData.registeringNewArabianHorseFoal.sex,
        emirate: getServicesRequestByIdData.registeringNewArabianHorseFoal.emirate,
        emirateDrop: {
          label: getServicesRequestByIdData.registeringNewArabianHorseFoal.emirateName,
          value: getServicesRequestByIdData.registeringNewArabianHorseFoal.emirate,
        },
        area: getServicesRequestByIdData.registeringNewArabianHorseFoal.area,
        areaDrop: {
          label: getServicesRequestByIdData.registeringNewArabianHorseFoal.areaName,
          value: getServicesRequestByIdData.registeringNewArabianHorseFoal.area,
        },
        isRegistration: getServicesRequestByIdData.registeringNewArabianHorseFoal.isRegistration,
        address: getServicesRequestByIdData.registeringNewArabianHorseFoal.address,
        mobile: getServicesRequestByIdData.registeringNewArabianHorseFoal.mobile,
        ownerComment: getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerNote === "null" || getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerNote === null ? "" : getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerNote,
        gpsLocationLink: `https://www.google.com/maps?q=${getServicesRequestByIdData.registeringNewArabianHorseFoal.latitude},${getServicesRequestByIdData.registeringNewArabianHorseFoal.longitude}`,
        term1: true,
        violationPaymentHorseRegistrationDelay: getServicesRequestByIdData.registeringNewArabianHorseFoal.violationPaymentHorseRegistrationDelay,
      });

      setSelectedLocation({
        lat: getServicesRequestByIdData.registeringNewArabianHorseFoal.latitude,
        lng: getServicesRequestByIdData.registeringNewArabianHorseFoal.longitude,
        fullAddress: "",
      })

      //another owner
      if (
        (getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerId !== getServicesRequestByIdData.registeringNewArabianHorseFoal.createdBy)
        && subOwnerProfilesByIdData.length > 0
        && getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {

        dispatch(FetchOwnerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownthunk(getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerId));

        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.registeringNewArabianHorseFoal.ownerId
          )[0].value,
        });
      }
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {

    //save
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSuccessfully",
            "Your Request Has Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "" && _status.current === "Draft") {

          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id == null ? createRegisteringNewArabianHorseFoalServiceRequestData.id : id}`;

          const encodeURI = encodeURIComponent(returnUrl);
          debugger;
          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id == null ? createRegisteringNewArabianHorseFoalServiceRequestData.id : id}&paymentType=9&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;

        } else if (_isOnlinePayment.current !== "" && _status.current === "Submit") {

          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}`;

          const encodeURI = encodeURIComponent(returnUrl);
          debugger;
          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=10&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;

        } else {
          navigate(`/profile?activeTab=${"e_services"}`);
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        setTimeout(() => {

          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}`;

          const encodeURI = encodeURIComponent(returnUrl);
          debugger;
          if (!!id) {
            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=9&userId=${localStorage.getItem(
              "EAHSUserID"
            )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
          }
        }, 1000);



        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });

      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  //consoles
  console.log(formModel)

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {/* content page */}
      <div className={serviceRequestHeadContainer}>
        {/* Request Embryo Transfer Right Purchace Agreement title */}
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>


        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      {/* Covering Certificate details */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.coveringCertificateDetails", "Covering Certificate Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.coveringCertificate", "Covering Certificate")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.coveringCertificate", "Covering Certificate"),
                value: "",
              },
              ...(!!ownerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownData &&
                ownerCoveringCertificatesForRegisteringNewArabianHorseFoalDropDownData.map((a) => ({
                  label: a.referenceNumber + " / " + translate("web.mare", "Mare:") + ": " + a.mare + " / " + translate("web.stallion", "Stallion:") + ": " + a.stallion,
                  value: a.id,
                }))),
            ]}
            value={formModel.coveringCertificateDrop}
            onChange={(e) => handleFormChange(e, "coveringCertificate")}
            placeholder={translate("web.coveringCertificate", "Covering Certificate")}
            name={"coveringCertificate"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"horse"}
            isDisabled={handelDisabledButton()}
            ref={coveringCertificateRef}
          />

          {errorCoveringCertificate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.mareHorse", "Mare Horse")}
            name={"mareHorse"}
            type={"text"}
            disabled={true}
            value={formModel.mareHorse}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.mareOwner", "Mare Owner")}
            name={"mareOwner"}
            type={"text"}
            disabled={true}
            value={formModel.mareOwner}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.stallionHorse", "Stallion Horse")}
            name={"stallionHorse"}
            type={"text"}
            disabled={true}
            value={
              formModel.stallionHorse
            }
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.stallionOwner", "stallion Owner")}
            name={"stallionOwner"}
            type={"text"}
            disabled={true}
            value={formModel.stallionOwner}
          />
        </div>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.coveringDate", "CoveringDate")}
            name={"coveringDate"}
            type={"text"}
            disabled={true}
            //value={formModel.coveringDate !== "" ? dayjs(formModel.coveringDate, "YYYY/MM/DD").format("DD/MM/YYYY") : formModel.coveringDate}
            value={formModel.coveringDate}
          />
        </div>
      </EahsForm>

      {/* Horse details */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseDetails", "Horse Details")}>
        <div className={eformInput}>
          <NetaqInput
            label={translate("web.name", "Name") + " (EN)"}
            name={"nameEn"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "nameEn")}
            value={formModel.nameEn}
            required={true}
            maxchars={27}
            disabled={handelDisabledButton()}
            ref={nameEnRef}
          />
          <span className="Gray_color">
            {
              translate(
                "web.matchingArabicEnglishName",
                "*Matching Arabic English Name*"
              )
            }
          </span>
          {errorNameEn && (
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.name", "Name") + " (AR)"}
            name={"nameAr"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "nameAr")}
            value={formModel.nameAr}
            required={true}
            maxchars={28}
            disabled={handelDisabledButton()}
            ref={nameArRef}
          />
          <span className="Gray_color">
            {
              translate(
                "web.matchingArabicEnglishName",
                "*Matching Arabic English Name*"
              )
            }
          </span>
          {errorNameAr && (
            <p style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </p>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            htmlTags={
              formModel.birthDate ?
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  {
                    dayjs(formModel.birthDate).format("DD/MM/YYYY")
                  }
                </p> :
                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                  DD/MM/YYYY
                </p>
            }
            name={"birthDate"}
            type={"normalDateService"}
            label={translate("web.birthDate", "Birth Date")}
            onChange={(e) => {
              handleFormChange(e);
              checkPenalty(id ?? null, formModel.coveringCertificate, e.target.value).then(res => { setHasPanelty(res) })
            }}
            value={formModel.birthDate}
            required={true}
            minDate={handelMinDateForBirthDate()}
            maxDate={handelMaxDateForBirthDate()}
            disabled={handelDisabledButton()}
            ref={birthDateRef}
          />
          {errorBirthDate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <label>
            {translate("web.color", "Color")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.color", "Color"),
                value: null,
              },
              ...(!!horseColorsData &&
                horseColorsData.map((a) => ({
                  label: a.nameEn,
                  value: a.id,
                }))),
            ]}
            value={formModel.colorDrop}
            onChange={(e) => handleFormChange(e, "color")}
            placeholder={translate("web.color", "Color")}
            name={"color"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            key={"color"}
            isDisabled={handelDisabledButton()}
            ref={colorRef}
          />
          {errorColor && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            key={'horseType'}
            type="select"
            name='horseType'
            label={translate('web.horseCategory', 'Horse Category')}
            value={selctedHorseType}
            required
            listSelect={horseTypeOptions}
            onChange={(selected) => setSelctedHorseType(selected)}
            ref={selctedHorseTypeRef}
          />
          {errorSelctedHorseType && (
            <span style={{ color: "red" }} >
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <label>
          {translate("web.sex", "Sex")}
          <i className=" colorred"> *</i>
        </label>
        <div className="row">
          <div className={eformCheckBox}>
            <NetaqInput
              name={"sex"}
              type={"radioServiceRequest"}
              value={"Stallion"}
              label={`${translate("web.stallion", "Stallion")}-`}
              onChange={(e) => handleFormChange(e, "sex")}
              checked={formModel.sex === "Stallion"}
              disabled={handelDisabledButton()}
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              name={"sex"}
              type={"radioServiceRequest"}
              value={"Mare"}
              label={`${translate("web.mare", "Mare")}-`}
              onChange={(e) => handleFormChange(e, "sex")}
              checked={
                formModel.sex === "Mare"
              }
              disabled={handelDisabledButton()}
            />
          </div>
        </div>
      </EahsForm>

      {/* horse Location title */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseLocation", "Horse Location")}>
        <div className={eformInput}>
          <NetaqInput
            type={"select"}
            label={translate("web.emirate", "Emirate")}
            placeholder={translate("web.emirate", "emirate")}
            name={"emirate"}
            listSelect={emiratelistoptions}
            value={formModel.emirateDrop}
            onChange={(e) => handleFormChange(e, "emirate")}
            required={true}
            disabled={handelDisabledButton()}
            ref={emirateRef}
          />
          {errorEmirate && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            type={"select"}
            label={translate("web.area", "Area")}
            placeholder={translate("web.area", "Area")}
            name={"area"}
            listSelect={regionsList}
            value={formModel.areaDrop}
            onChange={(evt) => handleFormChange(evt, "area")}
            required={true}
            disabled={handelDisabledButton()}
            ref={areaRef}
          />
          {errorArea && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={"col-md-12 col-sm-12 rtl mb-form-group mt-2"}>
          <MapWithSearchAndLocate
            setSelectedLocation={setSelectedLocation}
            selectedLocation={selectedLocation}
            setFullAddress={setFullAddress}
            isView={handelDisabledButton()}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            // label={translate("web.gpsLocationLink", "GPS Location Link")}
            label={translate("web.mapLocation", "Map Location")}
            name={"gpsLocationLink"}
            type={"text"}
            onChange={handleFormChange}
            // value={formModel.gpsLocationLink}
            value={selectedLocation.lat === "" ? "" : `https://www.google.com/maps?q=${selectedLocation.lat},${selectedLocation.lng}`}
            disabled={true}
            ref={mapLocationRef}
          />
          {errorMapLocation && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>
      </EahsForm>

      {/* How to receive a horse passport */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(
        "web.receiveHorsePassport",
        "How to receive a horse passport"
      )}>
        <div className="row">
          <div className={eformCheckBox}>
            <NetaqInput
              name={"receiveType"}
              key={"Registration"}
              type={"radioServiceRequest"}
              value={"Registration"}
              label={translate(
                "web.registrationOffice",
                "Received From EAHS Office"
              )}
              onChange={(e) => handleFormChange(e, "receiveType")}
              checked={
                formModel.isRegistration
              }
              disabled={handelDisabledButton()}
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              name={"receiveType"}
              key={"Post"}
              type={"radioServiceRequest"}
              value={"Post"}
              label={translate("web.postOffice", "Post Delivery")}
              onChange={(e) => handleFormChange(e, "receiveType")}
              checked={
                !formModel.isRegistration
              }
              disabled={handelDisabledButton()}
            />
          </div>
        </div>
        {
          !formModel.isRegistration &&
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.address", "Address")}
                name={"address"}
                type={"text"}
                placeholder={translate("web.enterFullAddress", "Enter Full Address")}
                onChange={handleFormChange}
                value={formModel.address}
                required={true}
                disabled={handelDisabledButton()}
                ref={addressRef}
              />
              {errorAddress && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                type={'phone'}
                value={formModel.mobile}
                label={translate("web.smsPhoneNo", "Mobile No")}
                name={'mobile'}
                placeholder={'971xxxxxxxxx'}
                required={true}
                onChange={setPhoneNumber}
                setIsPhoneNumberValid={setIsPhoneNumberValid}
                disabled={handelDisabledButton()}
                ref={mobileRef}
              />
              {!isPhoneNumberValid &&
                <div className='text-danger'>
                  {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                </div>
              }

              {errorMobile && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
          </>
        }
      </EahsForm>

      {/* Comments */}
      {handelShowGeneralComments() && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {handelShowOwnerComment() && (
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
              />
            </div>
          )}
        </EahsForm>
      )}

      {/* terms*/}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {handelShowoption2() && (
          <div className={eformTerms}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.registeringNewArabianHorseFoalNote1",
                "Registering New Arabian Horse Foal 1"
              ) + " ( " + getServiceDefinitionByIdData.penalty + translate(
                "web.delayMustBePaid",
                "Delay Must Be Paid"
              )}
              name="term1"
              checked={formModel.term1 || action != null}
              onChange={(e) => handleFormChange(e, "term1")}
              disabled={formModel.eventName === "" ? false : true}
            />
          </div>
        )}
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* buttons */}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit */}
        {handelShowGeneralButtons() && (
          <>
            {/* draft */}
            {handelShowDraftButton() &&
              <DraftBtn
                key={'draft'}
                onClick={() => handelFormSubmit("Draft", "", "Draft")}
              />
            }

            {/* pay later */}
            {handleShowPayLaterButton() && (
              <ApproveAndPayLaterBtn
                selectedAccountId={profile?.value}
                isApprove
                key={`<i class="fa-solid fa-wallet fa-lg marginrightleft-10"></i>                   
                          ${translate("web._submitAndPayLater", "Submit And Pay Later")}
                          `}
                onClick={() =>
                  handelFormSubmit(formModel.eventName === "DNANegative" ? "Submit" : "Draft", "no", "Pay")
                }
              />
            )}

            {/* pay */}
            {handleShowPayButton() &&
              <SubmitAndPay
                selectedAccountId={profile?.value}
                isSubmit={true}
                key={translate("web._submitPay", "Submit And Pay")}
                onClick={() =>
                  handelFormSubmit(formModel.eventName === "DNANegative" ? "Submit" : "Draft", "yes", "Pay")
                }
              />
            }

            {/* submit */}
            {handelShowSubmitButton() && (
              <SubmitServiceBtn
                key={translate("web.submit", "Submit")}
                onClick={() =>
                  handelFormSubmit("Submit", "", "Submit")
                }
              />

            )}
          </>
        )
        }
      </div>
    </>
  );
}
